module.exports = __webpack_public_path__ + "static/media/sa-cavalcante.e5c38f37.png";